import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { WidgetsName, ensureWidgetObjectHasMinimumProperties, Rights, WidgetDisplayMode } from 'jamespot-user-api';

import { shallowEqual } from 'react-redux';

import styled from 'styled-components';
import { Widget, WidgetEditor } from 'jamespot-front-business';
import { WidgetRemove } from './WidgetRemove';
import { useAppDispatch, useAppSelector } from '../../../../redux/store';

export const Footer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    border-top: 1px solid ${(props) => props.theme.color.grey1};
`;

export const Button = styled.button`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    background-color: ${(props) => props.theme.color.white};
    &:hover {
        background-color: ${(props) => props.theme.color.grey0};
    }
`;

export const WidgetFooterView = ({
    name,
    uniqid,
    mode,
    collaborationRights,
    handleOpenEditor,
}: {
    name: WidgetsName;
    uniqid: string;
    mode?: WidgetDisplayMode;
    collaborationRights?: Pick<Rights, 'update'>;
    handleOpenEditor?: () => void;
}) => {
    const intl = useIntl();
    const dispatch = useAppDispatch();
    const widgetObject = useAppSelector((state) => Widget.selectors.selectWidgetObject(state, uniqid), shallowEqual);
    const widgetObjectRights = useAppSelector(
        (state) => Widget.selectors.selectWidgetObjectRights(state, uniqid),
        shallowEqual,
    );

    const canUpdate = useMemo(
        () =>
            (widgetObject && widgetObjectRights && widgetObjectRights.update) ||
            (collaborationRights && collaborationRights.update),
        [widgetObject, widgetObjectRights, collaborationRights],
    );

    const canDelete = useMemo(
        () => widgetObject && widgetObjectRights && widgetObjectRights.delete,
        [widgetObject, widgetObjectRights],
    );

    const handleOnClick = useCallback(() => {
        dispatch(
            WidgetEditor.slice.actions.registerEditor({
                uniqid,
                name,
                mode,
            }),
        );
    }, [uniqid, dispatch, name, mode]);

    return canUpdate && ensureWidgetObjectHasMinimumProperties(widgetObject) ? (
        <Footer>
            <Button onClick={handleOpenEditor ?? handleOnClick}>
                {intl.formatMessage({ id: 'WIDGET_Set_Widget' })}
            </Button>
            {canDelete && <WidgetRemove id={widgetObject.id} type={widgetObject.type} uniqid={uniqid} />}
        </Footer>
    ) : (
        <></>
    );
};
